<template>
  <div>
    <modal
      class="abtg-modal"
      :width="800"
      height="auto"
      name="m-building">
      
      <div class="modal-dialog modal-lg abtg-modal-dialog" role="document">
        <div class="modal-content">
          
          <div class="modal-header">
            <h5 class="modal-title abtg__modal-title" id="exampleModalLabel2">
              {{ $t('mapping.label_modal_building') }}</h5>
            
            <div class="tools">
              <div class="abtg__close-button"><a @click="closeModal()"><i
                class="fas fa-times"></i></a></div>            
            </div>
          </div>
          
          
          <div class="modal-body">
            <form @submit.prevent="onSubmit()" class=" ">
              <div class="modal-body">
                <div class="row">
                  <div class="col-lg-12 col-xs-12">

                    <span v-if="content.formData.broken_link > 0" style="color:red">
                      <hr>
                      <i class="fas fa-ban"></i> {{$t('mapping.warning')}}
                      <hr>
                    </span>
                    
                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                    
                    >
                      <input class="mdl-textfield__input abtg__input" name="price" type="text"
                             v-model="content.formData.via">
                      <label class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_address') }}
                        <span
                          class="abtg__asterisk">*</span></label>
                      <p class="text-danger small" v-if="errors && errors.via">
                        {{ errors.via[0] }}</p>
                    </div>
                  
                  
                  </div>
                
                
                </div>
                
                <!-- Price, Rooms, Floors -->
                <div class="row">
                  <div class="col-lg-3 col-xs-12">
                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                      <input class="mdl-textfield__input abtg__input" name="price" type="text"
                             v-model="content.formData.prezzo" v-money="money">
                      <label class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_price') }}</label>
                      <p class="text-danger small"
                         v-if="errors && errors.prezzo">
                        {{ errors.prezzo[0] }}</p>
                    </div>
                  
                  
                  </div>
                  
                  <div class="col-lg-3 col-xs-12">
                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                      <input class="mdl-textfield__input abtg__input" name="room" type="text"
                             v-model="content.formData.locali"
                             v-money="money">
                      <label class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_room') }}
                        <span
                          class="abtg__asterisk">*</span></label>
                      <p class="text-danger small"
                         v-if="errors &&  errors.locali">
                        {{ errors.locali[0] }}</p>
                    </div>
                  
                  
                  </div>
                  
                  <div class="col-lg-3 col-xs-12">
                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                    >
                      
                      <input class="mdl-textfield__input abtg__input" name="price" type="text"
                             v-model="content.formData.mq"
                             v-money="money"
                      >
                      <label class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_mq') }}
                        <span
                          class="abtg__asterisk">*</span></label>
                      <p class="text-danger small" v-if="errors && errors.mq">
                        {{ errors.mq[0] }}</p>
                    </div>
                  
                  
                  </div>
                  <div class="col-lg-3 col-xs-12">
                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                    
                    >
                      <input class="mdl-textfield__input abtg__input" name="floor" type="text"
                             v-model="content.formData.piano"
                      
                      >
                      <label class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_floor') }}
                        <span
                          class="abtg__asterisk">*</span></label>
                      <p class="text-danger small"
                         v-if="errors && errors.piano">
                        {{ errors.piano[0] }}</p>
                    </div>
                  
                  
                  </div>
                
                </div>
                
                
                <!-- Lift, Bathroom, Renovation-->
                <div class="row">
                  
                  
                  <div class="col-lg-3 col-xs-12">
                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                    
                    >
                      <input class="mdl-textfield__input abtg__input" name="lift" type="text"
                             v-model="content.formData.ascensori">
                      <label class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_lift') }}</label>
                      <p class="text-danger small"
                         v-if="errors && errors.ascensori">
                        {{ errors.ascensori[0] }}</p>
                    </div>
                  
                  
                  </div>
                  
                  <div class="col-lg-3 col-xs-12">
                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                    
                    >
                      <input class="mdl-textfield__input abtg__input" name="bathroom" type="text"
                             v-model="content.formData.bagni"
                             v-money="money"
                      >
                      <label class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_bathroom') }}
                        <span
                          class="abtg__asterisk">*</span></label>
                      <p class="text-danger small"
                         v-if="errors && errors.bagni">
                        {{ errors.bagni[0] }}</p>
                    </div>
                  
                  
                  </div>
                  <div class="col-lg-3 col-xs-12">
                    <!-- <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                    >
                      <input class="mdl-textfield__input abtg__input" name="renovation"
                             type="text"
                             v-model="content.formData.ristrutturazione">
                      <label
                        class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_renovation') }}</label>
                      <p class="text-danger small"
                         v-if="errors && errors.ristrutturazione">
                        {{ errors.ristrutturazione[0] }}</p>
                    </div> -->
                  
                  </div>
                  <div class="col-lg-3 col-xs-12">
                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                    >
                      <input class="mdl-textfield__input abtg__input" name="bathroom" type="text"
                             v-model="content.formData.data"

                      >

                      <label class="mdl-textfield__label abtg__margin-input"
                             style="margin-top:-20px;"> {{$t('mapping.label_date')}} </label>
                      <p class="text-danger small abtg__error-select"
                         v-if="errors && errors.data">
                        {{ errors.data[0] }}</p>
                    </div>
                  </div>
                </div>
                
                
                <!-- Date, Link, Note-->
                <div class="row">
                  
                  
                  <div class="col-lg-12 col-xs-12">
                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                    >
                      
                      <input class="mdl-textfield__input abtg__input abtg_input-small" name="link"
                             type="text"
                             v-model="content.formData.link">
                      <label class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_link') }}</label>
                      <p class="text-danger small" v-if="errors && errors.link">
                        {{ errors.link[0] }}</p>
                      <a :href="DASH_IF_EMPTY(content.formData.link)" target="_blank"
                         v-if="content.formData.link && content.formData.link.length > 5"
                      >
                        {{$t('mapping.link_vai_annuncio')}}
                      </a>
                    </div>
                  
                  
                  </div>
                
                </div> <!-- // end row -->
                
                
                <div class="row">
                  <div class="col-lg-12 col-xs-12">
                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                    >
                                    <textarea class="mdl-textfield__input abtg__input abtg_input-small" name="note"
                                              type="text"
                                              v-model="content.formData.note"></textarea>
                      <label class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_note') }}</label>
                      <p class="text-danger small" v-if="errors && errors.note">
                        {{ errors.note[0] }}</p>
                    </div>
                  
                  
                  </div>
                  
                  <div class="col-xs-6">
                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                    >
                      <div class="form-check-inline mt-3">
                        <label class="form-check-label"><input class="form-check-input"
                                       name="type"
                                       type="radio"
                                       :value="1"
                                       v-model="content.formData.type"> {{$t('mapping.check_residenziale')}}</label>
                        &nbsp;&nbsp;&nbsp;
                        <label class="form-check-label"><input class="form-check-input"
                                      name="type"
                                      type="radio"
                                      :value="2"
                                      v-model="content.formData.type"> {{$t('mapping.check_commerciale')}}</label>
                      </div>
                      
                      <label class="mdl-textfield__label abtg__margin-input">{{$t('mapping.text_tipologia_immobile')}}</label>
                      <p class="text-danger small" v-if="errors && errors.type">
                        {{ errors.type[0] }}</p>
                    </div>
                  </div>



                  <div class="col-xs-5 col-xs-offset-1 ml-2">
                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width " style="text-align:right"
                    >
                      <div class="form-check-inline mt-3">
                        <label class="form-check-label"><input class="form-check-input"
                                       name="renovated"
                                       type="radio"
                                       :value="1"
                                       v-model="content.formData.renovated"> Sì</label>
                        &nbsp;&nbsp;&nbsp;
                        <label class="form-check-label"><input class="form-check-input"
                                      name="renovated"
                                      type="radio"
                                      :value="2"
                                      v-model="content.formData.renovated"> No</label>
                                               &nbsp;&nbsp;&nbsp;
                        <label class="form-check-label"><input class="form-check-input"
                                      name="renovated"
                                      type="radio"
                                      :value="3"
                                      v-model="content.formData.renovated"> "NI"</label>
                      </div>
                      
                      <label class="mdl-textfield__label abtg__margin-input" style=" ">{{$t('mapping.domanda_rinnovato')}}</label>
                      <p class="text-danger small" v-if="errors && errors.type">
                        {{ errors.type[0] }}</p>
                    </div>
                  </div>
                </div>
                
                <div class="row">
                  <div class="col">
                    <!-- EDIT MODE -->
                    <button type="submit"
                            class="  margin-right-10 btn-success float-right abtg__btn-star"
                    
                    >
                      
                      {{$t('mapping.bottone_salva')}}
                    </button>
                  
                  
                  </div>
                </div> <!-- // end row -->
              </div>
            </form>
          </div>
        
        </div>
      </div>
    
    </modal>
  </div>


</template>
<script>

import {mixin} from '@/helpers/helper'
import {Money} from 'v-money';
import DatePicker from 'vue2-datepicker';
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
  props: ['content'],
  mixins: [mixin],
  components: {Money, DatePicker},
  data: function () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      }
    }
  },
  computed: {
    ...mapState('n_mapping', ['errors']),
  },
  methods: {
    ...mapActions('n_mapping', ['sendMappingData']),
    ...mapMutations('n_mapping', ['SET_DATA']),
    onSubmit: function () {
      this.SET_DATA({name: 'formData', data: this.content.formData});
      this.sendMappingData({modal: this.$modal, reload: true});
      // this.closeModal();
    },
    closeModal: function () {
      this.$modal.hide('m-building');
      this.SET_DATA({name: 'errors', data: {}});
    },
  }
}
</script>
